/**
 * A minimal event channel for auth events raised outside the render tree (the axios interceptor,
 * Apollo's errorLink) that React code — `AuthProvider`, route guards — needs to react to. Kept
 * deliberately tiny rather than pulling in an event-emitter dependency for two event types.
 */

type ForceLogoutReason = 'refresh-failed' | 'server-logout';
type ForceLogoutListener = (reason: ForceLogoutReason) => void;

const forceLogoutListeners = new Set<ForceLogoutListener>();

/** Raised when a silent token refresh fails — the session cannot continue. */
export function emitForceLogout(reason: ForceLogoutReason): void {
  for (const listener of forceLogoutListeners) listener(reason);
}

export function onForceLogout(listener: ForceLogoutListener): () => void {
  forceLogoutListeners.add(listener);
  return () => forceLogoutListeners.delete(listener);
}
